import { Module } from 'vuex';
import { ProfileState, Roles } from '@/store/profile/types';
import { RootState } from '@/store/types';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state: ProfileState = {
  user: undefined,
  session: undefined,
  pages: [
    {
      to: {
        name: 'Profile',
      },
      name: 'Profile',
      allowedRoles: [Roles.SUPPLIER],
      isAllowed: false,
      icon: 'account_circle',
    },
    {
      to: {
        name: 'Entity',
        params: { entityName: 'Supplier' },
      },
      name: 'Supplier_plural',
      allowedRoles: [Roles.SUPERVISOR],
      isAllowed: false,
      icon: 'mdi-format-list-text',
    },
    {
      to: {
        name: 'Entity',
        params: { entityName: 'ApplicationHR' },
      },
      name: 'ApplicationHR_my_plural',
      allowedRoles: [Roles.COORDINATOR, Roles.HR, Roles.SUPPLIER],
      isAllowed: false,
      icon: 'mdi-format-list-text',
    },
    {
      to: {
        name: 'RatesPage',
      },
      name: 'Rates_page',
      allowedRoles: [Roles.HR, Roles.SUPERVISOR],
      isAllowed: false,
      icon: 'mdi-quadcopter',
    },
    // {
    //   to: {
    //     name: 'ApplicationTemplate',
    //   },
    //   name: 'ApplicationTemplates',
    //   allowedRoles: [Roles.COORDINATOR],
    //   isAllowed: false,
    //   icon: 'mdi-plus-circle-outline',
    // },
    {
      to: {
        name: 'RatesConflictsPage',
      },
      name: 'Rates_conflicts_page',
      allowedRoles: [Roles.HR, Roles.SUPERVISOR],
      isAllowed: false,
      icon: 'mdi-alert-circle-outline',
    },
    {
      to: {
        name: 'ApplicationActualsList',
      },
      name: 'Edit_application_actual',
      allowedRoles: [Roles.COORDINATOR, Roles.HR],
      isAllowed: false,
      icon: 'mdi-table-edit',
    },
    {
      to: {
        name: 'ConfirmationOfCompletedWork',
      },
      name: 'confirmation_of_completed_work',
      allowedRoles: [Roles.SUPPLIER],
      isAllowed: false,
      icon: 'mdi-checkbox-marked-outline',
    },
    {
      to: {
        name: 'AccountingSheetsList',
      },
      name: 'application_post_processing',
      allowedRoles: [
        Roles.COORDINATOR, Roles.HR, Roles.CONTROLLING, Roles.ACCOUNTANT, Roles.SIGNER, Roles.SUPPLIER,
      ],
      isAllowed: false,
      icon: 'mdi-earth',
    },
    {
      to: {
        name: 'FormationOfAccountingSheets',
      },
      name: 'formation_of_accounting_sheets',
      allowedRoles: [Roles.COORDINATOR, Roles.HR],
      isAllowed: false,
      icon: 'mdi-cash-multiple',
    },
    {
      to: {
        name: 'ReportConstructor',
      },
      name: 'Отчёт (конструктор)',
      allowedRoles: [Roles.COORDINATOR, Roles.HR, Roles.SUPERVISOR],
      isAllowed: false,
      icon: 'mdi-book-clock-outline',
    },
    {
      to: {
        name: 'OperationReport',
      },
      name: 'Отчёт по операциям',
      allowedRoles: [Roles.COORDINATOR, Roles.HR, Roles.SUPERVISOR, Roles.CONTROLLING],
      isAllowed: false,
      icon: 'mdi-book-clock-outline',
    },
    {
      to: {
        name: 'Pretensions',
      },
      name: 'Претензии',
      allowedRoles: [Roles.HR, Roles.SUPERVISOR, Roles.ACCOUNTANT, Roles.SIGNER, Roles.CONTROLLING]
        .concat(process.env.VUE_APP_BC33_SUPPLIER_MENU === 'true' ? [Roles.SUPPLIER] : []),
      isAllowed: false,
      icon: 'mdi-file-alert',
    },
    {
      to: { name: 'PretensionsReport' },
      name: 'Отчёт по претензиям',
      allowedRoles: [Roles.HR, Roles.SUPERVISOR, Roles.ACCOUNTANT, Roles.CONTROLLING],
      isAllowed: false,
      icon: 'mdi-file-chart',
    },
  ],
};

const namespaced = true;

const profile: Module<ProfileState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};

export default profile;
